import React from 'react';
import Paper from '@mui/material/Paper';
import StepIcon from '@mui/material/StepIcon';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { muiPalette } from './muiPalette';
import { muiTypography } from './muiTypography';

const ErrorStepIcon = props => {
  const { completed, active, error, ...rest } = props;

  if (error) {
    // overriding error icon in order to match Figma
    return (
      <ErrorOutlineIcon
        color="error"
        ownerState={{ completed, active, error }}
        {...rest}
      />
    );
  }

  return <StepIcon {...props} />;
};

export const stepperOverrides = {
  MuiStepper: {
    defaultProps: {
      component: Paper
    },
    styleOverrides: {
      root: {
        padding: 24,
        borderRadius: 0
      }
    }
  },
  MuiStepLabel: {
    defaultProps: {
      StepIconComponent: ErrorStepIcon
    },
    styleOverrides: {
      label: {
        fontSize: 14,
        '&.Mui-active': {
          color: muiPalette.palette.primary.main
        },
        '&.Mui-completed': {
          color: muiPalette.palette.text.primary,
          fontWeight: 300
        },
        '&.Mui-error': {
          color: 'inherit',
          '&.Mui-active': {
            color: muiPalette.palette.primary.main
          },
          '&.Mui-completed': {
            color: muiPalette.palette.text.primary
          }
        }
      },
      vertical: {
        padding: 0
      }
    }
  },
  MuiStepIcon: {
    styleOverrides: {
      text: { ...muiTypography.typography.caption, fontWeight: 500 },
      root: {
        '&.Mui-completed': {
          color: muiPalette.palette.success.main,
          '&.Mui-error': {
            color: muiPalette.palette.error.main
          }
        },
        '&.Mui-active': {
          '&.Mui-completed': {
            color: muiPalette.palette.success.main
          },
          '&.Mui-error': {
            color: muiPalette.palette.error.main
          }
        }
      }
    }
  },
  MuiStepButton: {
    styleOverrides: {
      root: {
        '&:focus-visible': {
          background: muiPalette.palette.action.focus,
          borderRadius: 4
        },
        '&:hover': {
          background: ({ active }) =>
            active ? 'transparent' : muiPalette.palette.action.hover,
          cursor: ({ active }) => (active ? 'default' : 'pointer'),
          borderRadius: 4
        }
      }
    }
  },
  MuiStepContent: {
    styleOverrides: {
      root: {
        borderColor: muiPalette.palette.grey[300],
        marginLeft: 9,
        marginTop: 8
      }
    }
  },
  MuiStepConnector: {
    styleOverrides: {
      line: { borderColor: muiPalette.palette.grey[300] },
      vertical: { marginLeft: 9, marginBottom: 8 }
    }
  }
};
